const specialties = [
  'Dermatology',
  'Dentistry',
  'Psychiatry',
  'Pediatrics and New Born',
  'Neurology',
  'Orthopedics',
  'Gynaecology and Infertility',
  'Ear, Nose and Throat',
  'Cardiology and Vascular Disease',
  'Allergy and Immunology',
  'Andrology and Male Infertility',
  'Audiology',
  'Cardiology and Thoracic Surgery',
  'Chest and Respiratory',
  'Diabetes and Endocrinology',
  'Diagnostic Radiology',
  'Dietitian and Nutrition',
  'Family Medicine',
  'Gastroenterology and Endoscopy',
  'General Practice',
  'General Surgery',
  'Geriatrics',
  'Hematology',
  'Hepatology',
  'Internal Medicine',
  'IVF and Infertility',
  'Laboratories',
  'Nephrology',
  'Neurosurgery',
  'Obesity and Laparoscopic Surgery',
  'Oncology',
  'Oncology Surgery',
  'Ophthalmology',
  'Osteopathy',
  'Pain Management',
  'Pediatric Surgery',
  'Phoniatrics',
  'Physiotherapy and Sport Injuries',
  'Plastic Surgery',
  'Rheumatology',
  'Spinal Surgery',
  'Urology',
  'Vascular Surgery'
];

module.exports = specialties;